import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    done: 'Done!',
    doneDescription:
      "Your funds have been claimed and you'll see them in your balance.",
    buttonText: 'Perfect!',
  },
};
